export enum DroppableZones {
  CONNECTED_INPUTS = 'CONNECTED_INPUTS',
  FREE_INPUTS = 'FREE_INPUTS',
}
